/**
 * 班牌/Cplate 等页面：根据左侧选中节点加载「所属机构」级联（与 DeptCourse 一致）。
 * 最后更新：2026-08-31
 */
import { getTeachingDepartmentTree } from '../api/modules/department'
import {
  resolveActiveSchoolId,
  initDeptCascaderFormOptions,
  sanitizeDeptCascaderIds,
} from '../utils/deptCascaderProps'

export default {
  data() {
    return {
      currentDepartmentData: null,
      currentDepartmentNode: null,
    }
  },
  methods: {
    /** 记录左侧机构树当前选中节点 */
    captureDepartmentTreeContext(data, node) {
      this.currentDepartmentData = data
      this.currentDepartmentNode = node
    },

    /** 级联选择器应使用顶部当前学校 ID */
    getSchoolIdForDeptCascader() {
      // 学校 Id 保持字符串，避免雪花 Id 被 Number() 截断。最后修改：2026-10-18
      const fromStore = resolveActiveSchoolId(this)
      if (fromStore) return fromStore
      if (this.SchoolId) return String(this.SchoolId)
      return ''
    },

    /** 按 pid 拉取教学部门子树 */
    fetchDeptTreeByPid(pid) {
      return getTeachingDepartmentTree({ pid }).then((res) => res.data && res.data.response)
    },

    /**
     * 回填级联选中值（弹窗打开后强制刷新一次，避免 key 变更导致不回显）
     * @param {object} form
     * @param {Array} path
     */
    applyDeptCascaderPath(form, path) {
      if (!form || !path || !path.length) return
      this.$set(form, 'Dids', path.slice())
      this.$nextTick(() => {
        this.$set(form, 'Dids', path.slice())
      })
    },

    /** 清洗 Dids，保留字符串大整数精度 */
    sanitizeDeptCascaderIds(ids) {
      return sanitizeDeptCascaderIds(ids)
    },

    /**
     * 初始化弹窗所属机构级联
     * @param {'add'|'edit'} formType
     * @param {number|string} [preselectDeptId]
     * @param {Array} [existingDids] - 编辑时接口返回的 Dids
     * @returns {Promise<number[]>} 默认选中的级联路径
     */
    initDeptFormSelection(formType, preselectDeptId, existingDids) {
      const schoolId = this.getSchoolIdForDeptCascader()
      if (!schoolId) {
        this.$message.warning('请先在顶部切换学校！')
        return Promise.reject(new Error('missing school id'))
      }
      return initDeptCascaderFormOptions({
        formType,
        selectedData: this.currentDepartmentData,
        selectedNode: this.currentDepartmentNode,
        preselectDeptId,
        departmentId: this.DepartmentId,
        existingDids: this.sanitizeDeptCascaderIds(existingDids),
        getSchoolId: () => schoolId,
        fetchTreeByPid: (pid) => this.fetchDeptTreeByPid(pid),
      }).then((result) => {
        this.options = result.options || []
        this.cascaderKey = (this.cascaderKey || 0) + 1
        return result.defaultPath || []
      })
    },
  },
}
